import { useCallback, useEffect, useState } from 'react'

import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'

import { FplDataGrid, FplDialogTitle, IGridColumn } from 'components/common'
import { GET_SUPPLIER_COVERAGE_PREVIEW } from 'graphql/queries/SupplierCoverageQueries'

const columns: IGridColumn[] = [
  { field: 'supplierName', headerName: 'Supplier Name', minWidth: 180, flex: 1, sortable: false },
  { field: 'contactName', headerName: 'Contact Name', minWidth: 150, flex: 1, sortable: false },
  { field: 'email', headerName: 'Email', minWidth: 200, flex: 1, sortable: false },
  { field: 'telephoneNumber', headerName: 'Phone', minWidth: 150, flex: 1, sortable: false },
]

interface IProps {
  bookingId?: string
  open: boolean
  onClose: () => void
}

export const OnePointSupplierCoverageDialog = (props: IProps) => {
  const { bookingId, open, onClose } = props

  const [supplierCount, setSupplierCount] = useState<number | null>(null)

  // Reset the count each time the dialog opens so a stale value is not shown while loading.
  useEffect(() => {
    if (open) {
      setSupplierCount(null)
    }
  }, [open])

  const handleDataLoadComplete = useCallback((data: any, loading: boolean) => {
    if (!loading) {
      setSupplierCount(data?.supplierCoveragePreview?.totalCount ?? 0)
    }
  }, [])

  const title =
    supplierCount === null
      ? 'Onepoint Supplier Coverage'
      : `Onepoint Supplier Coverage (${supplierCount} ${supplierCount === 1 ? 'Supplier' : 'Suppliers'})`

  return (
    <Dialog fullWidth maxWidth='md' open={open} onClose={onClose}>
      <FplDialogTitle onClose={onClose}>{title}</FplDialogTitle>
      <DialogContent dividers>
        <FplDataGrid
          query={GET_SUPPLIER_COVERAGE_PREVIEW}
          queryVariables={{ bookingId: Number(bookingId) }}
          skipQuery={!open || !bookingId}
          entityName='supplierCoveragePreview'
          columns={columns}
          toolbar={{ caption: 'Suppliers notified if this job is shared now' }}
          onDataLoadCompleteAction={handleDataLoadComplete}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
